import { GIF, PNG, WEBP } from "./mimeTypes.js";

export const animateableTypes = [WEBP, PNG, GIF];
